(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/mybets-common-wager/assets/javascripts/collections/boards.js') >= 0) return;  svs.modules.push('/components/numbergames/mybets-common-wager/assets/javascripts/collections/boards.js');

'use strict';

svs.numbergames.mybets_common_wager.collections.Boards = svs.numbergames.core.NumbergamesCollection.extend({
  model: svs.numbergames.mybets_common_wager.models.Board
});

 })(window);